import { render, staticRenderFns } from "./UploadLeadMailBoxCSV.vue?vue&type=template&id=f5627834&"
import script from "./UploadLeadMailBoxCSV.vue?vue&type=script&lang=js&"
export * from "./UploadLeadMailBoxCSV.vue?vue&type=script&lang=js&"
import style0 from "./UploadLeadMailBoxCSV.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports